import React, { useEffect, useRef } from 'react'
import useRedux from 'hooks/useRedux'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { KANBAN } from 'store/modules/kanban/types'
import * as kanbanActions from 'store/modules/kanban/actions'
import Kanban from '../components/Kanban'

const KanbanTab = () => {
  const { filtros } = useSelector<ApplicationState, KANBAN>(
    (state) => state.kanban
  )

  const { dispatch } = useRedux()
  const pipelineIdAnteriorRef = useRef<string | null>(null)

  useEffect(() => {
    dispatch(kanbanActions.verificaHierarquiaEDisparaGetsSaga())
    dispatch(kanbanActions.initializeWebSocketsChannelRetornoKanbanSaga())
    return () => {
      dispatch(kanbanActions.disconnectWebSocketsChannelRetornoKanbanSaga())
    }
  }, [dispatch])

  useEffect(() => {
    if (filtros.pipelineId) {
      dispatch(
        kanbanActions.atualizarInscricaoPipelineKanbanSaga(
          filtros.pipelineId,
          pipelineIdAnteriorRef.current
        )
      )
      pipelineIdAnteriorRef.current = filtros.pipelineId
    }
  }, [dispatch, filtros.pipelineId])

  return (
    <div>
      <Kanban />
    </div>
  )
}

export default KanbanTab
